import { useEffect } from 'react';
import { publicAxios } from './axios';
import { getCompanyDomain } from '../services/companyDomainGetSet';

const useCompanyAxios = () => {
  useEffect(() => {
    const companyDomain = getCompanyDomain();

    const requestIntercept = publicAxios.interceptors.request.use(
      config => {
        if (companyDomain && config.baseURL) {
          const [, rest] = config.baseURL.split('://');
          const currentDomain = rest?.split('/')[0];
          
          if (currentDomain && !currentDomain.startsWith(`${companyDomain}.`)) {
            config.baseURL = config.baseURL.replace('://', `://${companyDomain}.`);
          }
        }

        return config;
      },
      error => Promise.reject(error)
    );

    return () => {
      publicAxios.interceptors.request.eject(requestIntercept);
    };
  }, []);

  return publicAxios;
};

export default useCompanyAxios;